import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx"; // Import XLSX library to handle Excel files

const DisplayExcel = ({ file }) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);
        setTableData(jsonData); // Set the parsed data
      };
      reader.readAsArrayBuffer(file); // Read the file as an ArrayBuffer
    }
  }, [file]);

  return (
    <div className="overflow-x-auto table-responsive">
      {tableData.length > 0 ? (
        <table className="table dataselectiontable table-bordered">
          <thead className="bg-gray-200">
            <tr>
              {Object.keys(tableData[0]).map((key, index) => (
                <th
                  key={index}
                  className="border border-gray-300 px-4 py-2 text-left font-bold bg-[#0C3C54]"
                >
                  {key}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, rowIndex) => (
              <tr key={rowIndex} className="hover:bg-gray-100">
                {Object.values(row).map((value, colIndex) => (
                  <td
                    key={colIndex}
                    className="border border-gray-300 p-2"
                  >
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-gray-500">No data to display.</p>
      )}
    </div>
  );
};

export default DisplayExcel;
